import { useSelector } from "react-redux";
import { Navigate, Outlet } from "react-router-dom";

export default function PrivateRoute() {
  const { isAuthenticated } = useSelector((state) => state.auth);

  return isAuthenticated ? (
    <>
      <Outlet />
    </>
  ) : (
    <div style={{ minHeight: "100vh" }}>
      <Navigate to="/login" replace />
    </div>
  );
}
